module.exports = __webpack_public_path__ + "static/sydney-8268331d30a786e22b278169ab57c6c2.jpg";